import * as React from "react"
import { Button } from "react-bootstrap"
import { Typeahead, InputProps } from "react-bootstrap-typeahead"
import { FaAngleDown } from "react-icons/fa"
import State from "../../api/OrderRequests/OrderRequestsModel/State"

interface StateSelectProps {
  id?: string
  selected?: State
  selectedCode?: string
  states: State[] | undefined
  inputProps?: InputProps
  isInvalid?: boolean
  isDisabled?: boolean
  emptyLabel?: string
  placeholder?: string
  dropButtonIfInvalid?: boolean
  onChange: (item: State) => void
}

export default class StateSelect extends React.Component<StateSelectProps> {
  typeahead = React.createRef<Typeahead<State>>()

  render() {
    const disabled = this.props.isDisabled
    const selected = this.props.selected || this.props.selectedCode ? (this.props.states || []).find(item => item.Abbreviation.toLowerCase() === this.props.selectedCode?.toLowerCase()) : undefined
    return <Typeahead
      inputProps={this.props.inputProps}
      id={this.props.id}
      ref={this.typeahead}
      labelKey={"FullName"}
      filterBy={(option, props) => props.selected.length > 0 || option.FullName.toLowerCase().indexOf(props.text.toLowerCase()) !== -1 || option.Abbreviation.toLowerCase().indexOf(props.text.toLowerCase()) !== -1 }
      onChange={(items: State[]) => this.props.onChange(items[0])}
      disabled={disabled}
      options={this.props.states ? this.props.states : []}
      selected={selected ? [selected] : []}
      emptyLabel={this.props.emptyLabel}
      placeholder={this.props.placeholder}
      isInvalid={this.props.isInvalid}>
      {(this.props.dropButtonIfInvalid || !this.props.isInvalid) &&
        <Button disabled={disabled} variant="toggle" onClick={() => { this.typeahead.current?.toggleMenu() }}>
          <FaAngleDown />
        </Button>}
    </Typeahead>
  }

  static defaultProps = {
    id: "state",
    isInvalid: false,
    isDisabled: false,
    dropButtonIfInvalid: false,
    emptyLabel: "No State Found",
    placeholder: "Select"
  }
}
